import { create } from "zustand";

const KEY = "pm-theme";
export type Theme = "light" | "dark";

function readStored(): Theme {
  try {
    const stored = localStorage.getItem(KEY);
    if (stored === "dark" || stored === "light") return stored;
  } catch {
    /* sem storage */
  }
  return "light";
}

function apply(theme: Theme) {
  if (typeof document === "undefined") return;
  document.documentElement.classList.toggle("dark", theme === "dark");
  try {
    localStorage.setItem(KEY, theme);
  } catch {
    /* sem storage */
  }
}

/** Tema global (classe `.dark` no <html>), compartilhado por todos os componentes. */
const useThemeStore = create<{ theme: Theme; setTheme: (t: Theme) => void }>((set) => ({
  theme: readStored(),
  setTheme: (theme) => {
    apply(theme);
    set({ theme });
  },
}));

// Aplica já no carregamento do módulo (evita piscar o tema errado).
apply(useThemeStore.getState().theme);

export function useTheme() {
  const theme = useThemeStore((s) => s.theme);
  const setTheme = useThemeStore((s) => s.setTheme);
  return {
    theme,
    setTheme,
    toggle: () => setTheme(theme === "dark" ? "light" : "dark"),
  };
}
